import { TextField, TextFieldProps } from "@mui/material";

interface CardTextFieldProps extends Omit<TextFieldProps, "error"> {
  errorMessage?: string | false | undefined;
}

export default function CardTextField({
  errorMessage,
  ...props
}: CardTextFieldProps) {
  return (
    <TextField
      fullWidth
      variant="outlined"
      sx={{
        fontFamily: '"Lexend", sans-serif',
        "& .MuiOutlinedInput-root": {
          borderRadius: "8px",
          backgroundColor: "var(--neutral-50)",
          font: "var(--body-sm)",
          "& fieldset": {
            borderColor: "var(--neutral-200)",
          },
          "& .MuiInputBase-textarea": {
            padding: "0",
          },
          "& placeholder": {
            color: "var(--neutral-400)",
          },
        },
      }}
      error={!!errorMessage}
      helperText={errorMessage || ""}
      {...props}
    />
  );
}
